module.exports = __webpack_public_path__ + "img/NoEvent.c3712d68.svg";